<template>
    <DnPaginator
        class="base-paginator"
        v-bind="$attrs"
        :page-number-prefix-sr="t('a11y.paginator.page_prefix_sr')"
    >
        <template #labelPrevious>
            <BaseIcon
                class="base-paginator__icon"
                icon="chevron-left"
            />

            <div class="sr-only">{{ t('a11y.paginator.previous_sr') }}</div>
        </template>

        <slot />

        <template #labelNext>
            <BaseIcon
                class="base-paginator__icon"
                icon="chevron-right"
            />

            <div class="sr-only">{{ t('a11y.paginator.next_sr') }}</div>
        </template>
    </DnPaginator>
</template>

<script setup>
import DnPaginator from '@digitalnatives/paginator';

const { t } = useI18n();
</script>

<style src="./BasePaginator.less" lang="less" />
